import FingerprintJS from "@fingerprintjs/fingerprintjs";

let visitorIdPromise: Promise<string | undefined> | null = null;

function computeVisitorId(): Promise<string | undefined> {
  return FingerprintJS.load()
    .then((agent) => agent.get())
    .then((result) => result.visitorId)
    .catch(() => undefined);
}

export function getDeviceFingerprint(): Promise<string | undefined> {
  visitorIdPromise ??= computeVisitorId();
  return visitorIdPromise;
}

void getDeviceFingerprint();
